import { unref, type MaybeRef } from 'vue'
import type { ImageGridCell, ImageGridRow, ImageInfo } from '#shared/model/image-grid'

function createRow(imageInfos: ImageInfo[], startingIndex: number, maxImagesPerRow: number) {
  let totalRelativeWidth = 0

  const cells: ImageGridCell[] = []

  for (let i = startingIndex; i < imageInfos.length && i < startingIndex + maxImagesPerRow; i++) {
    const imageInfo = imageInfos[i]
    let relativeWidth = imageInfo.width / imageInfo.height
    if (relativeWidth > 3) relativeWidth = 3
    if (relativeWidth < 0.33) relativeWidth = 0.33

    const newTotalRelativeWidth = totalRelativeWidth + relativeWidth

    if (relativeWidth === 0 || newTotalRelativeWidth < 5) {
      cells.push({
        imageInfo,
        relativeWidth,
      })

      totalRelativeWidth = newTotalRelativeWidth
    }
  }

  let relativeHeight = 1 / totalRelativeWidth

  if (totalRelativeWidth < 1) {
    const scaleFactor = 1 / totalRelativeWidth
    cells.forEach(cell => (cell.relativeWidth *= scaleFactor))
    totalRelativeWidth = 1
  }

  return {
    cells,
    relativeHeight,
  }
}

export function getImageGridRows(imageInfos: ImageInfo[], maxImagesPerRow: MaybeRef<number> = 3) {
  const rows: ImageGridRow[] = []

  let currentIndex = 0
  while (currentIndex < imageInfos.length) {
    const row = createRow(imageInfos, currentIndex, unref(maxImagesPerRow))
    currentIndex += row.cells.length
    rows.push(row)
  }

  return rows
}
